import { categoryKey, sanitiseLevel, type IntoxicationLevel } from '../config/intoxication';
import { createSeededLevel } from '../sim/SeededLevel';
import { simulationFingerprint } from '../sim/fingerprint';
import { isSeed, parseSeed } from '../sim/seed';

/** Both personal bests and remote boards isolate dose, seed and simulation build. */
export function runCategoryKey(dose: IntoxicationLevel, seed = 0, fingerprint = simulationFingerprint(createSeededLevel(seed))): string {
  if (!isSeed(seed) || !/^[a-f0-9]{16}$/.test(fingerprint)) throw new Error('Invalid run identity');
  return `${categoryKey(dose)}-s${seed}-f${fingerprint}`;
}

export function parseRunCategory(raw: string): { seed: number; fingerprint: string } | null {
  if (raw.length > 80) return null;
  const match = /^(a(\d+\.\d{2})-d(\d+))-s(\d+)-f([a-f0-9]{16})$/.exec(raw);
  if (!match) return null;
  const seed = parseSeed(match[4]);
  const dose = sanitiseLevel({ alcoholPromille: Number(match[2]), drugsPercent: Number(match[3]) });
  if (seed === null || runCategoryKey(dose, seed, match[5]) !== raw) return null;
  return { seed, fingerprint: match[5] };
}
